/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FileChunkCreateByProjectFileIdsRequestDto } from '../models/file-chunk-create-by-project-file-ids-request-dto';
import { FileChunkResponseDto } from '../models/file-chunk-response-dto';
import { FileEmbeddingResponseDto } from '../models/file-embedding-response-dto';
import { MilvusInsertResponseDto } from '../models/milvus-insert-response-dto';
import { MilvusSearchRequestDto } from '../models/milvus-search-request-dto';
import { VectorEmbeddingCreateRequestDto } from '../models/vector-embedding-create-request-dto';

@Injectable({
  providedIn: 'root',
})
export class EmbeddingControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation embeddingControllerCreateChunk
   */
  static readonly EmbeddingControllerCreateChunkPath = '/vector-embeddings/chunk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createChunk()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createChunk$Response(params?: {
    body?: {  }
  }): Observable<StrictHttpResponse<Array<FileChunkResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EmbeddingControllerService.EmbeddingControllerCreateChunkPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FileChunkResponseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createChunk$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createChunk(params?: {
    body?: {  }
  }): Observable<Array<FileChunkResponseDto>> {

    return this.createChunk$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FileChunkResponseDto>>) => r.body as Array<FileChunkResponseDto>)
    );
  }

  /**
   * Path part for operation embeddingControllerCreateChunkByFileIds
   */
  static readonly EmbeddingControllerCreateChunkByFileIdsPath = '/vector-embeddings/chunk-by-file-ids';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createChunkByFileIds()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createChunkByFileIds$Response(params?: {
    body?: FileChunkCreateByProjectFileIdsRequestDto
  }): Observable<StrictHttpResponse<Array<FileChunkResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EmbeddingControllerService.EmbeddingControllerCreateChunkByFileIdsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FileChunkResponseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createChunkByFileIds$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createChunkByFileIds(params?: {
    body?: FileChunkCreateByProjectFileIdsRequestDto
  }): Observable<Array<FileChunkResponseDto>> {

    return this.createChunkByFileIds$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FileChunkResponseDto>>) => r.body as Array<FileChunkResponseDto>)
    );
  }

  /**
   * Path part for operation embeddingControllerMilvusInsert
   */
  static readonly EmbeddingControllerMilvusInsertPath = '/vector-embeddings/milvus-insert';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `milvusInsert()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  milvusInsert$Response(params?: {
    body?: Array<VectorEmbeddingCreateRequestDto>
  }): Observable<StrictHttpResponse<Array<MilvusInsertResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EmbeddingControllerService.EmbeddingControllerMilvusInsertPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MilvusInsertResponseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `milvusInsert$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  milvusInsert(params?: {
    body?: Array<VectorEmbeddingCreateRequestDto>
  }): Observable<Array<MilvusInsertResponseDto>> {

    return this.milvusInsert$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MilvusInsertResponseDto>>) => r.body as Array<MilvusInsertResponseDto>)
    );
  }

  /**
   * Path part for operation embeddingControllerSearch
   */
  static readonly EmbeddingControllerSearchPath = '/vector-embeddings/milvus-search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `search()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  search$Response(params?: {
    body?: MilvusSearchRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, EmbeddingControllerService.EmbeddingControllerSearchPath, 'get');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `search$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  search(params?: {
    body?: MilvusSearchRequestDto
  }): Observable<void> {

    return this.search$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation embeddingControllerCreateEmbedding
   */
  static readonly EmbeddingControllerCreateEmbeddingPath = '/vector-embeddings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEmbedding()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEmbedding$Response(params?: {
    body?: Array<VectorEmbeddingCreateRequestDto>
  }): Observable<StrictHttpResponse<Array<FileEmbeddingResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EmbeddingControllerService.EmbeddingControllerCreateEmbeddingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FileEmbeddingResponseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createEmbedding$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEmbedding(params?: {
    body?: Array<VectorEmbeddingCreateRequestDto>
  }): Observable<Array<FileEmbeddingResponseDto>> {

    return this.createEmbedding$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FileEmbeddingResponseDto>>) => r.body as Array<FileEmbeddingResponseDto>)
    );
  }

}
